const initialState = {
  list: [],
  rowsCount: 0,
  loading: 'idle',

  selectedItem: {
    data: null,
    loading: 'idle',
  },

  options: {
    data: {
      factoryConfig: {
        data: [],
        loading: 'idle',
      },
    },
    loading: 'idle',
  },
};

export default initialState;
